import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=a0f1c228"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports